/* Which Account a Mass / Priority / Automated messages page opens on (CONTEXT.md: Mass messages page).
   Pure, so the rules are testable without rendering the page. */

import type { Account } from '../api/client';

/** One remembered Account per browser, shared by the Mass, Priority and Automated messages pages. */
export const LAST_ACCOUNT_KEY = 'om.massPages.lastAccount';

/** The login's console Accounts the page may offer: `ids` null = every Account. */
export function offeredAccounts<A extends Pick<Account, 'account_id'>>(accounts: A[], ids: string[] | null | undefined): A[] {
  if (ids === null) return accounts;
  const allowed = new Set(ids ?? []);
  return accounts.filter((a) => allowed.has(a.account_id));
}

/** The URL's Account, else the last one used on either page, else the first offered. */
export function chooseAccount(offered: string[], fromUrl: string | null, last: string | null): string | undefined {
  if (fromUrl && offered.includes(fromUrl)) return fromUrl;
  if (last && offered.includes(last)) return last;
  return offered[0];
}

export function readLastAccount(): string | null {
  try {
    return window.localStorage.getItem(LAST_ACCOUNT_KEY);
  } catch {
    return null;
  }
}

export function rememberAccount(accountId: string): void {
  try {
    window.localStorage.setItem(LAST_ACCOUNT_KEY, accountId);
  } catch {
    // Private window or blocked storage: the URL still holds the choice.
  }
}
